<template>
  <transition
    :enterActiveClass="$style.errorStateTransition"
    :enterClass="$style.errorStateEnter"
    :leaveActiveClass="$style.errorStateTransition"
    :leaveToClass="$style.errorStateLeaveTo"
  >
    <div :class="$style.errorContainer">
      <h3 :class="$style.errorHeader">
        {{ headerText }}
      </h3>
      <img
        :class="$style.whatsNewEmptyImg"
        :src="imagePath"
      >
      <h5 :class="$style.errorSubtext">
        {{ subtext }}
      </h5>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'WhatsNewListEmpty',

  props: {
    headerText: {
      required: true,
      type: String,
    },

    imagePath: {
      required: true,
      type: String,
    },

    subtext: {
      required: true,
      type: String,
    },
  },
};
</script>

<style scoped module>
@value (fadeTransition) from '~css/transitions.css';

.errorContainer {
  margin: 70px auto;
  text-align: center;
  width: 450px;
}

.errorHeader {
  font-size: 20px;
  font-weight: 700;
}

.errorSubtext {
  font-size: 16px;
}

.errorStateEnter,
.errorStateLeaveTo {
  opacity: 0;
}

.errorStateTransition {
  transition: fadeTransition;
}

.whatsNewEmptyImg {
  margin: 50px 0;
  width: 350px;
}
</style>
